import React from 'react'
import LinkWithGradient from './linkWithGradient';
import withRequestCallModal from '../hocs/withRequestCallModal';

const RequestCallLink = withRequestCallModal(props => (
  <LinkWithGradient {...props}>Заказать звонок</LinkWithGradient>
))

export default RequestCallLink;